export default "__VITE_ASSET__C4uT$PSD__"